/**
 * @generated SignedSource<<4935a1ebe42a878b67bcddd95544e283>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuHighlightedPromotion_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly promotions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string;
              readonly highlight: boolean | null;
            };
          }>;
        } | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuHighlightedPromotion_Product";
};
export type ProductSkuHighlightedPromotion_Product$key = {
  readonly " $data"?: ProductSkuHighlightedPromotion_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuHighlightedPromotion_Product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuHighlightedPromotion_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    }
                  ],
                  "concreteType": "PromotionConnection",
                  "kind": "LinkedField",
                  "name": "promotions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PromotionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Promotion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "highlight",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "c03bfadb6e6ee667bd0b71e2104b32bb";

export default node;
